import { ChangeDetectionStrategy, Component, inject, Input, signal } from '@angular/core';
import { BaseModalComponent } from '../../../../core/layout/components/abstracts/base-modal.component';
import { ICard } from '../../core/interfaces/ICard';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { ProductsTableComponentextends } from '../../tables/products-table/products-table.component';
import { CardsService } from '../../core/services/CardsService';
import { finalize } from 'rxjs';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';

@Component({
  selector: 'app-add-products-modal',
  standalone: true,
  imports: [
    ModalComponent,
    TranslatePipe,
    ProductsTableComponentextends,
  ],
  templateUrl: './add-products-modal.component.html',
  styleUrl: './add-products-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddProductsModalComponent extends BaseModalComponent {

  @Input({ required: true }) card: ICard;

  public selectedProductIds = new Map<number, number>();
  public readonly isSubmitting = signal(false);

  private readonly _cardsService = inject(CardsService);

  public override open(val?: null): void {
    this.selectedProductIds.clear();
    super.open(val);
  }

  public submitSelectedProducts(): void {
    this.isSubmitting.set(true);

    this._cardsService.addProductsToCard(
      this.card.cardId,
      Array.from(this.selectedProductIds.keys()).map(id => ({ productId: id }))
    )
      .pipe(
        finalize(() => this.isSubmitting.set(false))
      )
      .subscribe({
        next: res => {
          this.formFinished.emit(res.data);
          this.close();
        },
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`add-products-to-card/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
